export default "__VITE_ASSET__B9oj3EsV__"